import { BUTTON_A_FIELD } from '../type_name'
const invalidValue = [ undefined, null]
export const headerHandler = header => {
    const header_clone = {...header}
    header_clone.align = header_clone.align || 'center'
    return header_clone
}
export default {
    name: BUTTON_A_FIELD,
    props: {
        value: {
            type:[String, Number, Object]
        },
        header: {
            type:[String, Number, Object]
        },
        index: {
            type: Number,
        },
        target: {
            type: Object,
        }
    },
    computed: {
        valueHandle() {
            if (invalidValue.includes(this.value) && !invalidValue.includes(this.header.default_value)) {
                return this.header.default_value
            }
            if (invalidValue.includes(this.value) && invalidValue.includes(this.header.default_value)) {
                return '-'
            }
            return <a on-click={this.call}>{this.value}</a>
        }
    },
    methods: {
        call() {
            const { callback } = this.header
            callback && callback(this.target, this.header, this.index)
        }
    },
    render() {
        return <span>
            {this.valueHandle}
        </span> 
        
    }
}